import { render, staticRenderFns } from "./exchangeRates.vue?vue&type=template&id=6e9002ea&scoped=true&"
import script from "./exchangeRates.vue?vue&type=script&lang=ts&"
export * from "./exchangeRates.vue?vue&type=script&lang=ts&"
import style1 from "./exchangeRates.vue?vue&type=style&index=1&id=6e9002ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9002ea",
  null
  
)

export default component.exports